import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

export const THEMES = [
  { id: "teal",    label: "Teal",    swatch: "#0f766e", accent: "#06b6d4" },
  { id: "indigo",  label: "Indigo",  swatch: "#4f46e5", accent: "#0ea5e9" },
  { id: "emerald", label: "Emerald", swatch: "#047857", accent: "#22c55e" },
  { id: "violet",  label: "Violet",  swatch: "#7c3aed", accent: "#6366f1" },
  { id: "amber",   label: "Amber",   swatch: "#b45309", accent: "#f97316" },
  { id: "rose",    label: "Rose",    swatch: "#be123c", accent: "#ec4899" }
];

const ThemeContext = createContext({
  theme: "teal",
  setTheme: () => {},
  themes: THEMES
});

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    try {
      return localStorage.getItem("bw_theme") || "teal";
    } catch {
      return "teal";
    }
  });

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "teal") {
      root.removeAttribute("data-theme");
    } else {
      root.setAttribute("data-theme", theme);
    }
    try { localStorage.setItem("bw_theme", theme); } catch { /* ignore */ }
  }, [theme]);

  const setTheme = useCallback((id) => setThemeState(id), []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes: THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
